export default __webpack_public_path__ + "static/bnk-card-cdac1af6f243fc21daf179801347982f.png";